import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE = "getSTANDARDGRNTableStructure";
export const UPDATE_TABLE_DATA = "getSTANDARDGRNTableData";
export const EXPORT_TABLE_DATA = "exportSTANDARDGRNTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setSTANDARDGRNTableStructure";
export const SET_TABLE_DATA = "setSTANDARDGRNTableData";
export const SET_TABLE_FILTER = "setSTANDARDGRNTableFilter";
export const SET_TABLE_PAGE = "setSTANDARDGRNTablePage";
export const SET_TABLE_PERPAGE = "setSTANDARDGRNTablePerPage";
export const SET_TABLE_SORTBY = "setSTANDARDGRNTableSortBy";
export const SET_TABLE_SORTORDER = "setSTANDARDGRNTableSortOrder";
export const SET_EXPORT_LINK = "setSTANDARDGRNExportLink";

const state = {
  export_link: null,
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
};

const getters = {
  /**
   * for table title, descripton
   * */
  getSTANDARDGRNTableProperties(state) {
    return state.table_structure.properties;
  },
  /**
   * for table permissions
   **/
  getSTANDARDGRNTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getSTANDARDGRNTableState(state) {
    // console.log("table state is ", state.table_state);
    return state.table_state;
  },

  getSTANDARDGRNTableHeaders(state) {
    return state.table_structure.columns;
  },

  getSTANDARDGRNTableFilters(state) {
    return state.table_structure.filters;
  },

  getSTANDARDGRNTableData(state) {
    return state.table_data.data;
  },

  getSTANDARDGRNExportUrl(state) {
    return state.export_link;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    // console.log(payload);
    return new Promise((resolve) => {
      ApiService.post("/warehouse_management/custom/standard_grn")
        .then(({ data }) => {
          // console.log("suc", data);
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      // ApiService.post("login", credentials)
      ApiService.post(
        "/warehouse_management/custom/standard_grn/datatable",
        payload
      )
        .then(({ data }) => {
          // console.log("data of datatable ", data);
          context.commit(SET_TABLE_DATA, data);
          resolve(data);

          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post(
        "/warehouse_management/custom/standard_grn/export",
        payload
      )
        .then(({ data }) => {
          // console.log("export data is ", data);
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
